module.exports = __webpack_public_path__ + "static/media/fgn_my.9134f359.png";